<template>
  <div class="historicalModelManagement-page">
    <div class="all-content-container">
      <div class="content-left-container">
        <!-- <el-image
      style="width: 100px; height: 100px"
      src="@/assets/img/u1367.png"
        :fit="fit"></el-image>-->
        <img src="@/assets/img/u1367.png" alt />
      </div>
      <div class="content-right-container">
        <div class="content-callback-btn">
          <h4>番茄_2019-12-06_001_admin</h4>
        </div>
        <div class="table-content-container">
          <div class="table-title-container">
            <h4>历史模型</h4>
          </div>
          <div class="table-content-title">
            <el-button plain>第一周</el-button>
            <el-button plain>第二周</el-button>
            <el-button plain>第三周</el-button>
            <el-button plain>第四周</el-button>
            <el-button plain>+新增</el-button>
          </div>
          <div class="table-content">
            <el-table
              :data="tableData"
              style="width: 150%"
              :header-cell-style="{background:'#f4f5f7'}"
            >
              <el-table-column align="center" prop="date" label="时间段" width="110">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.date" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="trsf" label="土壤水分" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.trsf" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="trwd" label="土壤温度" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.trwd" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="trph" label="土壤PH" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.trph" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="tryf" label="土壤盐分" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.tryf" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="trjs" label="土壤紧实度" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.trjs" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="ypwd" label="叶片温度" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.ypwd" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="ypsd" label="叶片湿度" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.ypsd" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="gcwd" label="冠层温度" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.gcwd" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="gzsc" label="光照时长" width="90">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.gzsc" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="kqwd" label="空气温度" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.kqwd" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="kqsd" label="空气湿度" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.kqsd" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="eyht" label="二氧化碳" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.eyht" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="gzqd" label="光照强度" width="95">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.gzqd" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="ghyx" label="光合有效幅度" width="110">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.ghyx" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" prop="dqyq" label="大气压强">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.dqyq" placeholder="请输入内容"></el-input>
                </template> -->
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "historicalDetailsManagement",
  data() {
    return {
      tableData: [
        {
          date: "00:00~06:00",
          trsf: "20%~30%",
          trwd: "11°C~18°C",
          trph: "7.2~7.4",
          tryf: "1.2%~1.2%",
          trjs: "18%~21%",
          ypwd: "19°C~20°C",
          ypsd: "15%~17%",
          gcwd: "19°C~20°C",
          gzsc: "0h",
          kqwd: "19°C~20°C",
          kqsd: "20%~23%",
          eyht: "15%~17%",
          gzqd: "15%~17%",
          ghyx: "15%~17%",
          dqyq: "1011pa~1020pa"
        },
        {
          date: "00:00~06:00",
          trsf: "20%~30%",
          trwd: "11°C~18°C",
          trph: "7.2~7.4",
          tryf: "1.2%~1.2%",
          trjs: "18%~21%",
          ypwd: "19°C~20°C",
          ypsd: "15%~17%",
          gcwd: "19°C~20°C",
          gzsc: "0h",
          kqwd: "19°C~20°C",
          kqsd: "20%~23%",
          eyht: "15%~17%",
          gzqd: "15%~17%",
          ghyx: "15%~17%",
          dqyq: "1011pa~1020pa"
        },
        {
          date: "00:00~06:00",
          trsf: "20%~30%",
          trwd: "11°C~18°C",
          trph: "7.2~7.4",
          tryf: "1.2%~1.2%",
          trjs: "18%~21%",
          ypwd: "19°C~20°C",
          ypsd: "15%~17%",
          gcwd: "19°C~20°C",
          gzsc: "0h",
          kqwd: "19°C~20°C",
          kqsd: "20%~23%",
          eyht: "15%~17%",
          gzqd: "15%~17%",
          ghyx: "15%~17%",
          dqyq: "1011pa~1020pa"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/historicalDetailsManagement.scss";
</style>